<div class="text-center pt-5 mt-5 grey-text">
  <i class="fa fa-ban mt-4" style="font-size: 8rem; color: #ededed"></i>
  <h1 class="display-4">404</h1>
  <h1>Lo sentimos, la página no ha sido encontrada.</h1>
  <a class="btn btn-default waves-light" href="javascript:void(0)" routerLink="/" mdbRippleRadius>Ir a inicio</a>
</div>
